"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var children_exports = {};
__export(children_exports, {
  NAVIGATOR_CONFIG: () => NAVIGATOR_CONFIG,
  getCustomNavigatorChildren: () => getCustomNavigatorChildren,
  isNavigatorConfigChild: () => isNavigatorConfigChild
});
module.exports = __toCommonJS(children_exports);
var import_react = require("react");
var NAVIGATOR_CONFIG = "__oneNavigatorConfig";
function isNavigatorConfigChild(child) {
  return (0, import_react.isValidElement)(child) && typeof child.type === "function" && child.type[NAVIGATOR_CONFIG] === true;
}
function getCustomNavigatorChildren(children) {
  var custom = [];
  import_react.Children.forEach(children, function(child) {
    if (child != null && !isNavigatorConfigChild(child)) {
      custom.push(child);
    }
  });
  return custom;
}
//# sourceMappingURL=children.js.map
